import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  GalleryDestinationComponent
} from '@ux/components/gallery-destination/gallery-destination/gallery-destination.component';
import { ImageModule } from '@ux/components/image/image.module';
import { GlobalPipesModule } from '@app/pipes/global-pipes.module';

@NgModule({
  declarations: [GalleryDestinationComponent],
  exports: [GalleryDestinationComponent],
  imports: [
    CommonModule,
    ImageModule,
    GlobalPipesModule
  ]
})
export class GalleryDestinationModule { }
